import cx from 'classnames'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import withHandlers from 'recompose/withHandlers'
import withProps from 'recompose/withProps'
import { bindActionCreators } from 'redux'
import { List } from 'immutable'
import IconSVG from 'svg-inline-react'

import { makeHasGate } from 'app/modules/gates/selectors'
import * as SegmentActions from 'app/modules/segment/actions'
import * as PlaybookActions from 'app/modules/playbook/actions'
import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as SegmentSelectors from 'app/modules/segment/selectors'
import * as UserSelectors from 'app/modules/user/selectors'

import { AudienceType } from 'app/modules/playbook/constants'

import staticSegmentSrc from '!svg-inline?removeTags=true!images/svg/check-in-box.svg'
import dynamicSegmentSrc from '!svg-inline?removeTags=true!images/svg/infinite.svg'

import SegmentSelect from './component'

const SegmentTypeToLabel = {
  ID_LIST: 'Static segment',
  QUERY: 'Dynamic segment',
}
const SegmentTypeToIcon = {
  ID_LIST: staticSegmentSrc,
  QUERY: dynamicSegmentSrc,
}

const mapStateToProps = state => ({
  userListIds: PlaybookSelectors.userListIds(state),
  isEmailPlaybook: PlaybookSelectors.getIsEmailPlaybook(state),
  segments: SegmentSelectors.segments(state),
  orgUsersById: UserSelectors.orgUsersById(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      setUserListIds: PlaybookActions.setUserListIds,
      setAudience: PlaybookActions.setAudience,
      hideSegmentSelect: PlaybookActions.hideSegmentSelect,
    },
    dispatch
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onChange: props => selectedSegments => {
      const selectedSegmentIds = List(selectedSegments).map(selection => selection.value)
      props.actions.setAudience(AudienceType.SEGMENT)
      props.actions.setUserListIds(selectedSegmentIds)
    },
    onCancel: props => () => {
      props.actions.hideSegmentSelect()
    },
  }),
  withProps(props => ({
    options: (props.extraOptions || List())
      .concat(props.segments)
      .map(segment => {
        const { name, id, authorId, type } = segment
        const author = props.orgUsersById.get(authorId)
        return {
          value: id,
          name: name,
          label: (
            <div className="flex">
              <IconSVG
                className={cx('icon segment-option-icon', `icon-type-${type.toLowerCase()}`)}
                src={SegmentTypeToIcon[type]}
              />
              <div className="segment-option-meta">
                <div className="segment-option-name">{name}</div>
                <div className="segment-option-description">
                  {SegmentTypeToLabel[type]} {!!author ? `created by ${author.name || author.email}` : ''}
                </div>
              </div>
            </div>
          ),
        }
      })
      .toArray(),
    value: props.value || props.userListIds.toJS(),
  }))
)(SegmentSelect)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/SegmentSelect/index.js